import { HIDDEN } from 'customer-data-objects/property/AccessLevel';
import { useAccessLevel } from 'customer-data-properties/accessLevel/AccessLevelContext';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { Link } from 'foundations-components/transitional/components/Link';
import PropertyCopy from '../../../card/secondaryProperties/PropertyCopy';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import { Flex } from 'foundations-components/components/Flex';
import { SecondaryPropertyDisplay } from '../../../card/secondaryProperties/SecondaryPropertyDisplay';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getUrlWithProtocol = str => {
  return /^https?:/i.test(str) ? str : `https://${str}`;
};

/**
 * Domain data is not clean, only recently did we add FE property validation preventing protocol
 *
 * @param domain
 * @returns domain without protocol
 */
export const getDomainWithoutProtocol = domain => {
  return domain.replace(/^(https?:\/\/)?/i, '');
};
const useGetCompanyChickletSecondaryDisplayLabels = ({
  properties,
  toObjectTypeId,
  objectId
}) => {
  const companyPhone = getPropertyValueFromProperties(properties, 'phone');
  const companyDomain = getPropertyValueFromProperties(properties, 'domain');
  const companyWebsite = getPropertyValueFromProperties(properties, 'website');
  const getHref = domain => {
    const domainWithoutProtocol = getDomainWithoutProtocol(domain);
    if (!companyWebsite || !companyWebsite.includes(domainWithoutProtocol)) {
      return getUrlWithProtocol(domain);
    }
    try {
      const websiteUrl = new URL(companyWebsite);
      const isSupportedProtocol = websiteUrl.protocol === 'https:' || websiteUrl.protocol === 'http:';
      const isDomainMatching = websiteUrl.hostname.localeCompare(domainWithoutProtocol, undefined, {
        sensitivity: 'accent'
      }) === 0;
      const isDomainWithWWWMatching = websiteUrl.hostname.localeCompare(`www.${domainWithoutProtocol}`, undefined, {
        sensitivity: 'accent'
      }) === 0;
      const hasMatchingSite = isDomainMatching || isDomainWithWWWMatching;
      if (!isSupportedProtocol || !hasMatchingSite) {
        return getUrlWithProtocol(domain);
      }
      return websiteUrl.href;
    } catch (error) {
      return getUrlWithProtocol(domain);
    }
  };
  const getAdditionalPropertyValue = propertyName => getPropertyValueFromProperties(properties, propertyName);
  const companyPhoneAccessLevel = useAccessLevel({
    objectType: toObjectTypeId,
    propertyName: 'phone'
  });
  const renderDomain = (domainName, companyHref) => {
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Link, {
        "data-selenium-test": "company-chicklet-domain",
        "data-test-id": "company-chicklet-domain",
        external: true,
        href: companyHref,
        truncate: true,
        children: domainName
      })
    });
  };
  const renderFormattedDomain = () => {
    if (!companyDomain) {
      return /*#__PURE__*/_jsx(SecondaryPropertyDisplay, {
        propertyLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.CompanySecondaryPropertyLabels.emptyDomain"
        })
      });
    }
    const companyHref = getHref(companyDomain);
    return /*#__PURE__*/_jsx(Flex, {
      justifyContent: "space-between",
      children: /*#__PURE__*/_jsx(PropertyCopy, {
        copyValue: companyHref,
        data: renderDomain(companyDomain, companyHref),
        propertyName: "domain"
      })
    });
  };
  const renderFormattedPhone = propertyDefinition => {
    if (companyPhoneAccessLevel === HIDDEN) {
      return null;
    }
    const phonePropertyValue = /*#__PURE__*/_jsx(FormattedPropertyV2, {
      objectTypeId: toObjectTypeId,
      objectId: `${objectId}`,
      value: companyPhone,
      getDraftValue: () => undefined,
      getSavedValue: getAdditionalPropertyValue
      // @ts-expect-error Known property issue as they have not updated the type definitions
      // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
      ,
      property: propertyDefinition
    });
    return !companyPhone ? /*#__PURE__*/_jsx(SecondaryPropertyDisplay, {
      propertyLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.CompanySecondaryPropertyLabels.emptyPhone"
      })
    }) : /*#__PURE__*/_jsx("div", {
      "data-selenium-test": "company-chicklet-phone",
      "data-test-id": "company-chicklet-phone",
      children: /*#__PURE__*/_jsx(PropertyCopy, {
        propertyName: "phone",
        data: phonePropertyValue
      })
    });
  };
  const propertyFormatters = {
    domain: renderFormattedDomain,
    phone: renderFormattedPhone
  };
  return {
    propertyFormatters,
    copyDisabled: true
  };
};
export default useGetCompanyChickletSecondaryDisplayLabels;